<template>
  <div class="testerArea">

    <div>
        <div class="btn1" @click="start">Start</div>&nbsp;&nbsp;
        <div class="btn1" @click="resetText">Reset</div>
    </div>

    <div class="svgArea">
      
      <div class="implantView">
        <viewport></viewport>
      </div>

      <div class="elements">
          <div class="SplitterContent">
              <typer :content="thecontent" :isActive="isTyperActive"></typer>
          </div>
      </div>

      <svg viewBox="0 0 800 500">
        <path :class="['linePath', isDrawingLines ? 'draw' : '']" d="M800 0 L400 250" stroke="#fff" stroke-width="2" fill="none"/>
        <path :class="['linePath', isDrawingLines ? 'draw' : '']" d="M750 0 L400 250" stroke="#fff" stroke-width="2" fill="none"/>
        <!--
        <path class="path" fill="none" stroke="#fff" stroke-width="4" d="M66.039,133.545c0,0-21-57,18-67s49-4,65,8
        s30,41,53,27s66,4,58,32s-5,44,18,57s22,46,0,45s-54-40-68-16s-40,88-83,48s11-61-11-80s-79-7-70-41
        C46.039,146.545,53.039,128.545,66.039,133.545z"/>  
        -->
      </svg>
    </div>

  </div>
</template>

<style>
    .testerArea
    {
        background-color: rgb(15, 15, 15);
        color:#fff;
        min-height: 100vh;
        position: relative;
    }
    .testerArea .testerInner
    {
        width: 70%;
        clear: both;
        margin: auto;
        padding-top: 200px;

    }
    body::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }

    .SplitterContent
    {
        float: left;
        width: 400px;
        font-size: 16px;
        line-height:22px;
        /* padding: 20px; */
    }
    .btn1
    {
        background-color: #24b2f2;
        color: #fff;
        border-radius: 30px;
        padding: 10px 20px;
        display: inline-block;
        cursor: pointer;
    }
    .svgArea
    {
      position: absolute;
      width: 80vw;
      height: 50vw;
      border: solid 2px #202020;
      top:50%;left: 50%;
      transform: translate(-50%,-50%);
    }
    .elements
    {
      position:absolute;
      bottom:50px;
      left:450px;
    }
    .implantView
    {
      position:absolute;
      top:50px;
      top:50px;
    }

.linePath {
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
}
.linePath.draw
{
    animation: dash 3s linear;
    animation-delay: 0.3s;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1.000);
}
@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}
</style>

<script>
  import Typer from "@/components/typer.vue";  
  import ViewPort from "@/components/ViewPort.vue";  
  import { mapActions, mapState } from "vuex";
  
  export default 
  {
    data(){
      return{
        isDrawingLines:false,
        isTyperActive:false,
        thecontent:'The conical, root-shaped geometry of the LANCE+ and its variable threads are designed to enable excellent primary stability - offering the ultimate choice for a wide range of clinical cases and loading protocols LANCE+ also features a triple thread geometry which increases the implant insertion rate (2.25mm), allowing for a simpler and faster implant placement.',
        site_data:null,
        isMenuOpen:false
      }
    },
    components:
    {
      typer:Typer,
      viewport: ViewPort
    }, 
    computed: {
    },
    created: function () 
    {      
      this.preloadFonts();
    },
    methods: {
        resetText(){
            this.isTyperActive = false;
        },
        start(){
            this.isTyperActive = true;
            this.isDrawingLines = true;
        },

        //...mapActions(["loadSiteData","setSiteReady"]),
        preloadFonts()
        {
        var vm = this;
        if (document && document.fonts) {  
          //CSS Font Loading API
          //https://developer.mozilla.org/en-US/docs/Web/API/CSS_Font_Loading_API
          
          const font1 = new FontFace("Inter", "url(https://fonts.googleapis.com/css?family=Inter:200,300,400,500&display=swap&subset=latin-ext)");
          document.fonts.add(font1);
          font1.load();
          document.fonts.ready.then(() => {            
            //alert("font loaded");
            //add hidden text
            //setTimeout(() => {              
              //vm.setSiteReady(true);
            //}, 300);
          });
      } else {
          vm.setSiteReady(true);// Fallback if API does not exist 
      }
    },      
    }
  }
</script>
